/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

export enum TreatmentQueueStatusType {
  Queued = 'Queued',
  InProgress = 'InProgress',
  Completed = 'Completed'
}
